import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars() {
  return <div className="flex" aria-label="5 out of 5 stars" data-id="element-425" data-mp="3gojl1dq0gzoj">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-[#FFC531] text-[#FFC531]" aria-hidden="true" data-id="element-426" data-mp="3kqer0viw018n" data-mpi={i} />)}
    </div>;
}